import styled from 'styled-components';

export const LargeText = styled.div`
  font-size: 48px;
  line-height: 48px;
  font-weight: 600;
  color: var(--color-blue-50);
`;
